import React, {Component} from 'react';
import {Hero} from "../../components/hero/Hero";
import {AboutUs} from "../../components/about-us/AboutUs";
import {ContactUsHiddenFormSection} from "../../components/contact-us/ContactUsHiddenFormSection";
import {CaseStorySection} from "../../components/case-stories/CaseStorySection";
import {NewsListSection} from "../../components/news/NewsListSection";
import {Solutions} from "../../components/solutions/Solutions";
import {connect} from "react-redux";
import {isoDateFormat} from "../../util/DateFormat";
import {BasicAnimation} from "../../components/animations/BasicAnimation";
import {Helmet} from "react-helmet";
import striptags from "striptags";

export class HomeContainer extends Component {

  constructor(props) {
    super(props);

    let state = {};

    if(this.props.homePage && this.props.homePage.acf){
      state.heroTitle = this.props.homePage.acf.obx_hero_title;
      state.heroLead = this.props.homePage.acf.obx_hero_lead;
      state.introTitle = this.props.homePage.acf.obx_introduction_title;
      state.introLead = this.props.homePage.acf.obx_introduction_lead;
      state.aboutUs = {
        image: this.props.homePage.acf.obx_about_us_featured,
        content: this.props.homePage.acf.obx_about_us_content
      }
    }

    try {
      state.heroImage = this.props.homePage._embedded["wp:featuredmedia"][0].source_url;
    } catch(e){}

    this.state = state;
  }

  componentDidMount(){
    let caseStoryProps = null;

    try {
      const caseStory = this.props.caseStory[0];

      caseStoryProps = {
        slug: caseStory.slug,
        title: caseStory.title && caseStory.title.rendered,
        date: isoDateFormat(caseStory.date),
        excerpt: caseStory.excerpt && caseStory.excerpt.rendered,
        thumbnail: (() => {
          let image = null;

          try {
            image = caseStory._embedded["wp:featuredmedia"][0];
          } catch (e) {
          }

          return image;
        })(),
        heroImage:(() => {
          let image = null;

          try {
            image = caseStory.acf.obx_hero_image.sizes.large;
          } catch (e) {
          }

          return image;
        })()
      };

    } catch(e){}

    if(caseStoryProps)
      this.setState({ caseStoryProps });
  }

  render() {
    return (

      <div className="content">

        <Helmet>
          <title>Obelux Aviation Lights</title>
          <meta name="og:image" content={require('../../assets/images/obelux.jpg')}></meta>
        </Helmet>

        <BasicAnimation>
        <header>
            <Hero title={this.state.heroTitle}
                  subtitle={this.state.heroLead}
                  image={this.state.heroImage || require('../../assets/images/obelux-www-intro_contr.jpg')}
                  align="left"/>
        </header>
        <AboutUs data={this.state.aboutUs}/>
        <Solutions/>
        <ContactUsHiddenFormSection/>
        {
          Boolean(this.state.caseStoryProps) &&
          <CaseStorySection { ...this.state.caseStoryProps } />
        }
        <NewsListSection/>
        </BasicAnimation>
      </div>

    );
  }
}

export const Home = connect(
  state => ({
    homePage: state.resolve.data && state.resolve.data.homePage,
    caseStory: state.resolve.data && state.resolve.data.newest_case_story
  })
)(HomeContainer);



// WEBPACK FOOTER //
// ./src/views/home/Home.js